import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Targeting } from "@front/m19-api-client";

@Component({
  selector: "app-blacklist-view",
  template: ` <div class="flex flex-wrap">
    @for (item of blacklist; track item; let last = $last) {
      <div class="item m-2" [ngClass]="item.matchType">
        {{ item.targetingValue }}
      </div>
    }
  </div>`,
  imports: [CommonModule],
  styleUrls: ["./blacklist-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlacklistViewComponent {
  @Input()
  blacklist: Targeting[] = [];
}
